(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const initializeHeroLoop = (component) => {
    if (component.dataset.mobileSwipeLoop === 'true') return;

    const slider = component.querySelector('[id^="Slider-"]');
    const previousButton = component.querySelector('button[name="previous"]');
    const nextButton = component.querySelector('button[name="next"]');
    const slides = Array.from(component.querySelectorAll('.slideshow__slide'));

    if (!slider || !previousButton || !nextButton || slides.length < 2) return;

    component.dataset.mobileSwipeLoop = 'true';

    let gesture = null;
    let resumeTimer;

    const scheduleAutoplayResume = () => {
      clearTimeout(resumeTimer);
      if (!component.autoplayButtonIsSetToPlay || typeof component.play !== 'function') return;
      resumeTimer = window.setTimeout(() => component.play(), 4000);
    };

    slider.addEventListener(
      'pointerdown',
      (event) => {
        if (!mobileQuery.matches) return;

        const maxScroll = slider.scrollWidth - slider.clientWidth;
        gesture = {
          x: event.clientX,
          y: event.clientY,
          startedAtFirst: slider.scrollLeft <= 2,
          startedAtLast: slider.scrollLeft >= maxScroll - 2,
        };

        clearTimeout(resumeTimer);
        if (typeof component.pause === 'function') component.pause();
      },
      { passive: true }
    );

    slider.addEventListener(
      'pointerup',
      (event) => {
        if (!gesture || !mobileQuery.matches) {
          gesture = null;
          return;
        }

        const deltaX = event.clientX - gesture.x;
        const deltaY = event.clientY - gesture.y;
        const isHorizontalSwipe = Math.abs(deltaX) >= 48 && Math.abs(deltaX) > Math.abs(deltaY);

        if (isHorizontalSwipe && gesture.startedAtFirst && deltaX > 0) {
          previousButton.click();
        } else if (isHorizontalSwipe && gesture.startedAtLast && deltaX < 0) {
          nextButton.click();
        }

        gesture = null;
        scheduleAutoplayResume();
      },
      { passive: true }
    );

    slider.addEventListener(
      'pointercancel',
      () => {
        gesture = null;
        scheduleAutoplayResume();
      },
      { passive: true }
    );
  };

  const initialize = () => {
    document
      .querySelectorAll('[id$="__le_seven_home_hero"] slideshow-component')
      .forEach(initializeHeroLoop);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
